import PropTypes from 'prop-types'

import SignedOutForm, {
  SignedOutFormContainer,
  LowerLink
} from 'components/authentication/SignedOutForm'
import InputTextField from 'components/common/InputTextField'
import Password from 'components/authentication/form-fields/Password'

export default function SignInForm({
  email,
  password,
  handleEmailChange,
  handlePasswordChange,
  handlePasswordLogin,
  handleGoogleLogin,
  handleSamlLogin,
  submitting
}) {
  return (
    <SignedOutFormContainer data-test-signin-form>
      <SignedOutForm
        title="Log in"
        onSubmit={event => {
          event.preventDefault()
          handlePasswordLogin()
        }}
      >
        <InputTextField
          data-test-signin-email
          autoComplete="email"
          focusOnMount={true}
          label="Email"
          name="email"
          value={email}
          onChange={event => handleEmailChange(event.target.value)}
        />
        <Password
          handleChange={event => handlePasswordChange(event.target.value)}
          handleGoogle={handleGoogleLogin}
          handleSaml={handleSamlLogin}
          isLoading={!email || submitting}
          password={password}
          signInMethods={['password', 'google', 'saml']}
        />
      </SignedOutForm>
      <div css={{ display: 'flex', justifyContent: 'space-between' }}>
        <LowerLink
          data-test-signed-out-below-link
          css={{ textAlign: 'left' }}
          to="/password-reset"
        >
          Forgot Password?
        </LowerLink>
        <LowerLink
          data-test-signup-link
          css={{ textAlign: 'right' }}
          data-track-action="route-to-sign-up"
          data-track-category="unauthenticated"
          data-track-on="click"
          to="/signup"
        >
          New to Gremlin? Sign up for free
        </LowerLink>
      </div>
    </SignedOutFormContainer>
  )
}

SignInForm.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  handlePasswordLogin: PropTypes.func.isRequired,
  handleGoogleLogin: PropTypes.func.isRequired,
  handleSamlLogin: PropTypes.func.isRequired
}

SignInForm.defaultProps = {
  email: '',
  password: ''
}
